export const gvUrl = (window as any).ENV?.GV_URL;
